// Configure your import map in config/importmap.rb. Read more: https://github.com/rails/importmap-rails
// import "@hotwired/turbo-rails"
// import "controllers"

import * as bootstrap from 'bootstrap'
import { initTranslationFieldToggle } from '../utils/translationFieldToggle'
import { initCategoryGroupToggle } from '../utils/categoryGroupToggle'

window.bootstrap = bootstrap

// Set global variables from body data attributes
window.defaultAvatar = document.body.dataset.defaultAvatar || ''
window.locale = document.body.dataset.locale || 'ja'

window.addEventListener("DOMContentLoaded", () => {
  // Initialize translation field toggles
  initTranslationFieldToggle()

  // Initialize category group toggles
  initCategoryGroupToggle()
  const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]')
  const popoverList = [...popoverTriggerList].map(popoverTriggerEl => new bootstrap.Popover(popoverTriggerEl))

  const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
  const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))

  document.querySelectorAll('[data-clipboard-text]').forEach((el) => {
    el.addEventListener('click', () => {
      const tooltip = bootstrap.Tooltip.getOrCreateInstance(el)
      const text = el.getAttribute('data-clipboard-text')

      navigator.clipboard.writeText(text).then(() => {
        el.setAttribute('data-bs-original-title', 'Copied!')
        tooltip.show()

        setTimeout(() => {
          tooltip.hide()
          el.setAttribute('data-bs-original-title', 'Copy')
        }, 1500)
      }).catch(err => {
        console.error("Failed to copy:", err)
      })
    })
  })
})

// Event delegation for data-method links (CSP-compliant - no inline onclick handlers needed)
document.addEventListener('click', (e) => {
  const anchor = e.target.closest('a[data-method]')
  if (!anchor) return

  const method = (anchor.dataset.method || 'GET').toUpperCase()
  if (method === 'GET') return

  e.preventDefault()

  const message = anchor.dataset.confirm
  if (message && !confirm(message)) return

  const href = anchor.href
  if (!href) return

  const form = document.createElement('form')
  form.method = 'POST'
  form.action = href
  form.style.display = 'none'
  document.body.appendChild(form)

  if (method !== 'POST') {
    const methodInput = document.createElement('input')
    methodInput.type = 'hidden'
    methodInput.name = '_method'
    methodInput.value = method
    form.appendChild(methodInput)
  }

  const csrfParam = document.querySelector('meta[name=csrf-param]')
  const csrfToken = document.querySelector('meta[name=csrf-token]')

  if (csrfParam && csrfToken) {
    const csrfInput = document.createElement('input')
    csrfInput.type = 'hidden'
    csrfInput.name = csrfParam.content
    csrfInput.value = csrfToken.content
    form.appendChild(csrfInput)
  }

  form.submit()
})
